import type { KeyboardEvent } from 'react';

/** Manual activation: moving keyboard focus never starts a dashboard session or API action. */
export default function CharacterFilmTabs({ label, items, selected, onSelect }: {
  label: string; items: { id: string; label: string; disabled?: boolean }[];
  selected: string; onSelect: (id: string) => void;
}) {
  function navigate(event: KeyboardEvent<HTMLDivElement>) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const buttons = Array.from(event.currentTarget.querySelectorAll<HTMLButtonElement>('button:not(:disabled)'));
    if (!buttons.length) return;
    const index = buttons.indexOf(event.target as HTMLButtonElement);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1
      : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
    event.preventDefault(); buttons[next].focus();
  }
  return <div className="character-film-tabs" role="tablist" aria-label={label} onKeyDown={navigate}>
    {items.map(item => <button key={item.id} type="button" role="tab" aria-selected={selected === item.id}
      disabled={item.disabled} tabIndex={selected === item.id ? 0 : -1} onClick={() => onSelect(item.id)}>{item.label}</button>)}
  </div>;
}